import React, { useState, useEffect } from 'react'
import { Link } from 'gatsby'
import { useStore } from '../../lib/context'

import { observer } from 'mobx-react-lite'
import { motion } from 'framer-motion'
import css from 'styled-jsx/css'
import { Logo, NavLink, MobileExitArticleButton, MobileDropdown } from './'
import { useLocation } from '@reach/router'

const { className, styles } = css.resolve`
	div {
		height: var(--nav-bar-height);
		min-height: var(--nav-bar-height);
		width: 100%;
		padding: 0 1.25rem;
		display: flex;
		justify-content: space-between;
		z-index: 100;
		grid-column: span 12;
	}
	@media only screen and (min-width: 768px), (pointer: coarse) {
		div {
			transform: none !important;
		}
	}
	@media only screen and (max-width: 768px), (pointer: coarse) {
		div {
			height: var(--nav-bar-height-mobile);
			transform: translateY(0);
			padding: 0 1.25rem;
			padding-right: 10px;
			border-bottom: 1px solid var(--color--gray);
			position: fixed !important;
			overflow: hidden;
		}
	}
`

const CommunityButton = () => {
	return (
		<div>
			<Link to={'/community/'}>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150.3 150.3">
					<g id="Layer_2" data-name="Layer 2">
						<g id="Arrow">
							<g id="Ellipse_1" data-name="Ellipse 1">
								<path d="M75.15,4A71.15,71.15,0,1,1,4,75.15,71.23,71.23,0,0,1,75.15,4m0-4A75.15,75.15,0,1,0,150.3,75.15,75.16,75.16,0,0,0,75.15,0Z" />
							</g>
							<circle cx="111.83" cy="75.15" r="7" />
							<circle cx="38.47" cy="75.15" r="7" />
							<circle cx="75.15" cy="75.15" r="7" />
						</g>
					</g>
				</svg>
			</Link>
			<style jsx>{`
				svg {
					height: 40px;
					width: 40px;
				}
				div {
					height: 40px;
					width: 40px;
				}
			`}</style>
		</div>
	)
}

const Carrot = () => {
	return (
		<svg
			width="15px"
			height="9px"
			viewBox="0 0 15 9"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g
				id="Page-1"
				stroke="none"
				stroke-width="1"
				fill="none"
				fill-rule="evenodd"
				opacity="0.5"
				stroke-linecap="round"
				stroke-linejoin="bevel"
			>
				<path
					d="M11.2370705,-1.95230667 L4.64902868,3.48616082 C4.32656246,3.74834322 4.12786177,4.132984 4.10065407,4.54769333 C4.12486833,4.96252626 4.3242269,5.34752606 4.64902868,5.60671035 L11.2370705,11.0476933"
					id="Path-Copy-4"
					stroke="#000000"
					stroke-width="1.5"
					transform="translate(7.668862, 4.547693) scale(1, -1) rotate(90.000000) translate(-7.668862, -4.547693) "
				></path>
			</g>
		</svg>
	)
}

const MobileNavBar = observer(
	({
		animated,
		noPadding,
		hideOnScroll,
		route,
		wholeLogoMobile,
		hasExitButton,
	}) => {
		const location = useLocation()

		const {
			uiStore: {
				updateMapActiveFilterMobile,
				navBar__textColor,
				map__activeFilterMobile,
				updateNavBarTextColor,
				directory__mobileMenuOpen,
				toggleMobileDirectoryMenu,
			},
		} = useStore()
		const [hamburgerOpen, setHamburgerOpen] = useState(false)

		useEffect(() => {
			//updateNavBarTextColor(hamburgerOpen ? '#fff' : '#FE64B4')
		}, [hamburgerOpen])
		const isCommunity = location?.pathname.includes('/community');
		
		const whiteNav =
			location?.pathname === '/' ||
			location?.pathname === '/business' ||
			location?.pathname === '/being' ||
			location?.pathname === '/business/' ||
			location?.pathname === '/being/' ||
			isCommunity

		const links = [
			{ label: 'Business', link: '/business/' },
			{ label: 'Being', link: '/being/' },
			{ label: 'Beyond', link: '/beyond/'}
		]

		const {
			uiStore: { navBar__color, hideMobileNavBar },
		} = useStore()

		const transition = {
			opacity: { duration: 0.4 },
			translateY: { duration: 0.4 },
		}

		const setBusinessActive = () => {
			updateMapActiveFilterMobile('Business')
			window.history.pushState('Business', 'Business', '/business/')
		}
		const setBeingActive = () => {
			updateMapActiveFilterMobile('Being')
			window.history.pushState('Being', 'Being', '/being/')
		}

		const navBarUp = hideOnScroll && hideMobileNavBar

		return (
			<>
				<motion.div
					style={{
						position: route === '/community' ? 'relative' : 'fixed',
					}}
					transition={transition}
					animate={{
						y: navBarUp ? -(12 * 8) : 0,
						height: directory__mobileMenuOpen
							? 'calc(3*var(--nav-bar-height-mobile))'
							: 'var(--nav-bar-height-mobile)',
						backgroundColor: whiteNav
							? !directory__mobileMenuOpen
								? isCommunity
									? 'rgba(0,0,0,0)'
									: '#fff'
								: navBar__textColor
							: navBar__color,
					}}
					className={className}
				>
					<Logo
						animated={animated}
						noPadding={noPadding}
						route={route}
						wholeLogoMobile={wholeLogoMobile}
					/>

					<div className="nav-links">
						{links.map((l) => (
							<NavLink animated={animated} key={l.label} {...l} />
						))}
					</div>
					{hasExitButton && <MobileExitArticleButton />}

					<div className="community">
						<NavLink noPadding link={'/community/'} label="Community" />
					</div>
					<div className="community-mobile">
						<MobileDropdown />
					</div>

					<style jsx>{`
						.close {
							display: none;
						}
						.community-mobile {
							display: none;
						}
						.community {
							height: 100%;
							display: block;
						}
						.nav-links {
							display: flex;
							flex-direction: row;
						}

						@media only screen and (max-width: 768px), (pointer: coarse) {
							.close {
								height: 100%;
								display: flex;
								align-items: center;
								width: 50px;
							}
							.nav-links {
								display: none;
							}
							.nav-link {
								padding: 0 1.5rem;
							}
							.community-link {
								display: none;
							}
							.community-mobile {
								height: calc(3 * var(--nav-bar-height-mobile));

								align-items: flex-start;
								display: ${hasExitButton ? 'none' : 'flex'};
							}
							.links {
								display: flex;
								flex-direction: column;
							}
							.link {
								font-family: 'Elizeth';
								font-weight: 500;
								color: black;
								text-transform: uppercase;
								padding-right: 1.25rem;
								font-size: var(--font--xs);
								height: var(--nav-bar-height-mobile);
								display: flex;
								justify-content: flex-end;
								align-items: center;
							}
							.carrot {
								height: var(--nav-bar-height-mobile);
								display: flex;
								align-items: center;
								transition-duration: 0.5s;
								transform-origin: center center;
								-webkit-transform: rotateX(
									${directory__mobileMenuOpen ? '180deg' : '0deg'}
								);
								transform: rotateX(
									${directory__mobileMenuOpen ? '180deg' : '0deg'}
								);
							}
							.community {
								display: none;
							}
						}
					`}</style>
					{styles}
				</motion.div>
			</>
		)
	}
)

MobileNavBar.defaultProps = {
	position: 'fixed',
	backgroundColor: 'transparent',
	color: 'var(--color-black)',
}

export default MobileNavBar
